import { Country } from '@/models/country';
import type { AiModelContent } from '../aiLeagueTypes';
import placeholderImage from '@/assets/ai-league/placeholder.svg';

export const CLAUDE_AI_CONTENT: AiModelContent = {
  id: 'claude',
  tabLabel: 'Claude',
  displayName: 'Claude',
  countryList: [
    Country.FR,
    Country.ES,
    Country.GB_ENG,
    Country.DE,
    Country.CO,
    Country.TR,
    Country.MA,
    Country.UY,
    Country.JP,
    Country.SE,
  ],
  listValid: true,
  responseTimeSeconds: 590,
  imageSrc: placeholderImage,
  justificationText: `Methodology & justification

Odds-driven seed allocation. France and Spain are locked together at the top of the markets, with England a length back in third. Polymarket currently assigns a 16% win probability to France, with Spain essentially level. Those three occupy ranks 1–3 to maximise the value of the ×10/×9/×8 multipliers.

Germany at rank 4 for group-stage point inflation. Germany drew into the group with the lowest average FIFA ranking — Group E contains Curaçao, the lowest-ranked team in the tournament. Germany will likely score 10–15 goals in the group stage alone. That raw-point windfall, multiplied by ×7, makes rank 4 for Germany arguably the single highest-confidence decision in the entry.

Colombia as lead intermediate. Colombia has veteran big guns including Bayern's Luis Díaz, Palmeiras' Jhon Arias, and Benfica's Richard Rios, with James Rodríguez still pulling the strings. They should advance comfortably as Group K runners-up behind Portugal.

Türkiye as premium outsider. After a 24-year absence, Turkey return to the World Cup with a generation demonstrating clear structural improvement — their attacking threat is rated on a par with USA to prevail in Group D. Euro 2024 QF form plus a soft draw (Paraguay, Australia) gives realistic knockout-round upside at ×5.

Morocco (Group C 2nd behind Brazil), Uruguay (Group H 2nd behind Spain), Japan (Group F 2nd behind Netherlands) fill ranks 7–9 as near-certain group-stage progressors with genuine knockout potential. Sweden satisfies the second-outsider constraint at minimum-cost rank 10.

Biggest risk: France at rank 1 (×10). France then lost 2-1 to Ivory Coast in a friendly on June 4, which has seemingly spooked traders. An early shock exit would devastate the entry score. The upside — a WC-winning ~100 raw points × 10 = ~1,000 points — justifies the placement, but it is the entry's defining gamble.`,
};
